import Vue from "vue";
import Vuex from "vuex";
import createLogger from "vuex/dist/logger";

Vue.use(Vuex);

const debug = false;

export default new Vuex.Store({
  modules: {},
  strict: true, // debug,
  plugins: debug ? [createLogger()] : []
});
